import {info} from "services-comun/modules/browser/log";

import { Auth } from "../../../../services/auth";
import { IConfig } from "../../../../config";
import { Ruta, IRuta } from "../../../ruta";

export class EditarVideos extends Ruta {
    /* STATIC */
    public static build(config: IConfig, id: number): EditarVideos {
        return new this({
            id,
            ruta: `${config.router.basePath}/redaccion/videos/editar/`,
        });
    }

    /* INSTANCE */
    public constructor(data: IRuta) {
        super(data);
    }

    public async check(path: string): Promise<void> {
        if (!path.startsWith(this.data.ruta)) {
            return Promise.reject("Redaccion/Videos/Edit: Rechazada");
        }
    }

    public async load(auth: Auth, config: IConfig, state?: any): Promise<void> {

        info("Cargando NavBar");
        const {NavBar} = await import(/* webpackChunkName: "navbar" */ `../../../../componentes/navbar`);
        await NavBar.load(auth, config, state);
        info("Cargando Redaccion/Videos");
        const {EditarVideos} = await import(/* webpackChunkName: "redaccion-noticias" */ `../../../../componentes/redaccion/videos/editar`);
        await EditarVideos.load(auth, config, state);
    }

    public async unload(): Promise<void> {
        // info("Descargando NavBar");
        // const {NavBar} = await import(/* webpackChunkName: "navbar" */ `../../../componentes/navbar`);
        // await NavBar.unload();
        info("Descargando Redaccion/Videos");
        const {EditarVideos} = await import(/* webpackChunkName: "redaccion-noticias" */ `../../../../componentes/redaccion/videos/editar`);
        await EditarVideos.unload();
    }

    public async updateEstado(state?: any): Promise<void> {
        info("Actualizando el estado de NavBar");
        const {NavBar} = await import(/* webpackChunkName: "navbar" */ `../../../../componentes/navbar`);
        await NavBar.updateEstado(state);
        info("Actualizando el estado de Redaccion/Videos");
        const {EditarVideos} = await import(/* webpackChunkName: "redaccion-noticias" */ `../../../../componentes/redaccion/videos/editar`);
        await EditarVideos.updateEstado(state);
    }
}
